<template>
  <div class="calculator">
    <b-container>
      <div class="inner">
        <div class="calculator-wrapper">
          <div class="chose">
            <h2>Рассчитать стоимость</h2>
            <p>Весь функционал системы доступен по подписке.</p>
            <p>
              Для рассчета стоимости укажите продолжительность
              <br />акции и планируемое количество рабочих мест
              <br />регистраторов.
            </p>
            <p class="smParagraph">
              Данный рассчет носит исключительно информационный характер
              <br />и ни при каких условиях не является публичной офертой.
            </p>
          </div>
          <div class="chose-right">
            <div class="chose-wrapper">
              <div class="chose">
                <p class="title">Длительность акции</p>
                <p class="smParagraph">
                  Чем дольше подписка, тем выгоднее!
                  <br />Тарифный шаг - 1 месяц
                </p>
                <multiselect
                  v-model="duration"
                  track-by="option"
                  label="option"
                  placeholder="1 месяц"
                  :options="durations"
                  :searchable="false"
                  :allow-empty="false"
                  @input="updateFields(duration, registrator)"
                >
                  <template slot="selection" v-if="duration === 1">
                    <span class="multiselect__single">1 месяц</span>
                  </template>
                </multiselect>
              </div>
              <div class="chose">
                <p class="title">Регистраторы</p>
                <p class="smParagraph">
                  Укажите количество рабочих мест
                  <br />для регистраторов
                </p>
                <multiselect
                  v-model="registrator"
                  track-by="option"
                  label="option"
                  placeholder="1 человек"
                  :options="registrators"
                  :searchable="false"
                  :allow-empty="false"
                  @input="updateFields(duration, registrator)"
                >
                  <template slot="selection" v-if="registrator === 1">
                    <span class="multiselect__single">1 человек</span>
                  </template>
                </multiselect>
              </div>
              <div class="chose">
                <p class="title">Уникальные участники</p>
                <p class="smParagraph">
                  Рассчет строится из опыта ранее проведенных
                  <br />мероприятий и показывает вероятное количество
                  <br />уникальных участников за весь период акции
                </p>
                <input v-model="this.uniquePeople" class="input" type="text" disabled />
              </div>
            </div>
            <span class="price">Итого: {{this.price}} руб/мес</span>
            <ComModal :promise="promise"></ComModal>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import ComModal from "@/components/commercial-modal";

export default {
  data() {
    return {
      duration: { option: "1 месяц", count: 1 },
      durations: [
        { option: "1 месяц", count: 1 },
        { option: "2 месяца", count: 2 },
        { option: "3 месяца", count: 3 },
        { option: "4 месяца", count: 4 },
        { option: "5 месяцев", count: 5 },
        { option: "6 месяцев", count: 6 },
        { option: "7 месяцев", count: 7 },
        { option: "8 месяцев", count: 8 },
        { option: "9 месяцев", count: 9 },
        { option: "Более 9 месяцев", count: 10 }
      ],
      registrator: { option: "1 человек", count: 1 },
      registrators: [
        { option: "1 человек", count: 1 },
        { option: "2 человека", count: 2 },
        { option: "3 человека", count: 3 },
        { option: "4 человека", count: 4 },
        { option: "5 человек", count: 5 },
        { option: "6 человек", count: 6 },
        { option: "7 человек", count: 7 },
        { option: "8 человек", count: 8 },
        { option: "Более 9 человек", count: 9 }
      ],
      promise: `Мы вышлем вам предложение и иногда будем писать о новостях и новых возможностях программы.`,
      uniquePeople: `8000 участников`,
      price: 86000
    };
  },
  methods: {
    updateFields(duration, registrator) {
      this.uniquePeople = `${8000 *
        duration.count *
        registrator.count} участников`;

      let const1 = 40000 * (1 + 1 / duration.count) * duration.count;
      let const2 = 5000 * registrator.count * (1 + 0.1 * duration.count);

      let price = (const1 + const2) / duration.count;
      price = Math.round(price / 1000) * 1000;
      this.price = price;
    }
  },
  components: {
    Multiselect,
    ComModal
  }
};
</script>